import { OffersV3Header } from './OffersV3Header';
import { OffersV3SingleOfferTerm } from './OffersV3SingleOfferTerm';
import { OffersV3TermSelector } from './OffersV3TermSelector';
import { OffersV3OfferDetails } from './OffersV3OfferDetails';
import { OffersV3Disclaimer } from './OffersV3Disclaimer';
import { OffersV3Help } from './OffersV3Help';
import { OffersV3DiscountAlert } from './OffersV3DiscountAlert';
import { OffersV3Customize } from './OffersV3Customize';

export default {
    OffersV3Header,
    OffersV3SingleOfferTerm,
    OffersV3TermSelector,
    OffersV3OfferDetails,
    OffersV3Disclaimer,
    OffersV3Help,
    OffersV3DiscountAlert,
    OffersV3Customize
};
